export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterField {
  id: string;
  label: string;
  options: FilterOption[];
}

export const LEAD_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'new', label: 'New' },
      { value: 'contacted', label: 'Contacted' },
      { value: 'qualified', label: 'Qualified' },
      { value: 'proposal', label: 'Proposal' },
      { value: 'converted', label: 'Converted' },
      { value: 'lost', label: 'Lost' },
    ],
  },
  {
    id: 'source',
    label: 'Source',
    options: [
      { value: 'website', label: 'Website' },
      { value: 'referral', label: 'Referral' },
      { value: 'social', label: 'Social Media' },
      { value: 'email', label: 'Email Campaign' },
      { value: 'cold', label: 'Cold Call' },
    ],
  },
];

export const SUPPORT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'category',
    label: 'Category',
    options: [
      { value: 'all', label: 'All Categories' },
      { value: 'technical', label: 'Technical' },
      { value: 'account', label: 'Account' },
      { value: 'billing', label: 'Billing' },
      { value: 'general', label: 'General' },
    ],
  },
  {
    id: 'priority',
    label: 'Priority',
    options: [
      { value: 'all', label: 'All Priorities' },
      { value: 'urgent', label: 'Urgent' },
      { value: 'high', label: 'High' },
      { value: 'medium', label: 'Medium' },
      { value: 'low', label: 'Low' },
    ],
  },
];

export const TRADE_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'open', label: 'Open' },
      { value: 'closed', label: 'Closed' },
      { value: 'pending', label: 'Pending' },
    ],
  },
];

export const ACCOUNT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'all', label: 'All Status' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'expired', label: 'Expired' },
      { value: 'suspended', label: 'Suspended' },
    ],
  },
  {
    id: 'type',
    label: 'Type',
    options: [
      { value: 'all', label: 'All Types' },
      { value: 'live', label: 'Live' },
      { value: 'demo', label: 'Demo' },
    ],
  },
];

export const LEVERAGE_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'all', label: 'All Status' },
      { value: 'approved', label: 'Approved' },
      { value: 'pending', label: 'Pending' },
      { value: 'rejected', label: 'Rejected' },
    ],
  },
];

export const ADMIN_ACCOUNT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'pending', label: 'Pending' },
      { value: 'closed', label: 'Closed' },
    ],
  },
  {
    id: 'accountType',
    label: 'Account Type',
    options: [
      { value: 'Standard', label: 'Standard' },
      { value: 'Premium', label: 'Premium' },
      { value: 'VIP', label: 'VIP' },
      { value: 'ECN', label: 'ECN' },
    ],
  },
  {
    id: 'currency',
    label: 'Currency',
    options: [
      { value: 'USD', label: 'USD' },
      { value: 'EUR', label: 'EUR' },
      { value: 'GBP', label: 'GBP' },
      { value: 'JPY', label: 'JPY' },
    ],
  },
  {
    id: 'riskLevel',
    label: 'Risk Level',
    options: [
      { value: 'low', label: 'Low' },
      { value: 'medium', label: 'Medium' },
      { value: 'high', label: 'High' },
    ],
  },
  {
    id: 'verificationStatus',
    label: 'Verification',
    options: [
      { value: 'verified', label: 'Verified' },
      { value: 'pending', label: 'Pending' },
      { value: 'unverified', label: 'Unverified' },
    ],
  },
];

export const PAYMENT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'completed', label: 'Completed' },
      { value: 'pending', label: 'Pending' },
      { value: 'failed', label: 'Failed' },
    ],
  },
  {
    id: 'type',
    label: 'Type',
    options: [
      { value: 'deposit', label: 'Deposit' },
      { value: 'withdrawal', label: 'Withdrawal' },
      { value: 'transfer', label: 'Transfer' },
    ],
  },
  {
    id: 'method',
    label: 'Method',
    options: [
      { value: 'bank', label: 'Bank Transfer' },
      { value: 'card', label: 'Credit Card' },
      { value: 'crypto', label: 'Cryptocurrency' },
      { value: 'internal', label: 'Internal Transfer' },
    ],
  },
];

export const ORDER_HISTORY_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'open', label: 'Open' },
      { value: 'closed', label: 'Closed' },
    ],
  },
  {
    id: 'type',
    label: 'Type',
    options: [
      { value: 'buy', label: 'Buy' },
      { value: 'sell', label: 'Sell' },
    ],
  },
  {
    id: 'symbol',
    label: 'Symbol',
    options: [
      { value: 'EUR/USD', label: 'EUR/USD' },
      { value: 'GBP/USD', label: 'GBP/USD' },
      { value: 'USD/JPY', label: 'USD/JPY' },
      { value: 'AUD/USD', label: 'AUD/USD' },
      { value: 'USD/CAD', label: 'USD/CAD' },
      { value: 'EUR/GBP', label: 'EUR/GBP' },
      { value: 'NZD/USD', label: 'NZD/USD' },
      { value: 'USD/CHF', label: 'USD/CHF' },
      { value: 'EUR/JPY', label: 'EUR/JPY' },
      { value: 'GBP/JPY', label: 'GBP/JPY' },
      { value: 'USD/SGD', label: 'USD/SGD' },
      { value: 'EUR/AUD', label: 'EUR/AUD' },
      { value: 'XAU/USD', label: 'XAU/USD' },
    ],
  },
];

export const ADMIN_SUPPORT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'open', label: 'Open' },
      { value: 'in-progress', label: 'In Progress' },
      { value: 'resolved', label: 'Resolved' },
      { value: 'closed', label: 'Closed' },
    ],
  },
  {
    id: 'priority',
    label: 'Priority',
    options: [
      { value: 'urgent', label: 'Urgent' },
      { value: 'high', label: 'High' },
      { value: 'medium', label: 'Medium' },
      { value: 'low', label: 'Low' },
    ],
  },
  {
    id: 'category',
    label: 'Category',
    options: [
      { value: 'trading', label: 'Trading' },
      { value: 'payment', label: 'Payment' },
      { value: 'account', label: 'Account' },
      { value: 'technical', label: 'Technical' },
      { value: 'general', label: 'General' },
    ],
  },
];

export const CLIENT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'approve', label: 'Approve' },
      { value: 'reject', label: 'Reject' },
      { value: 'pending', label: 'Pending' },
    ],
  },
];

export const DEMO_ACCOUNT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'expired', label: 'Expired' },
    ],
  },
  {
    id: 'leverage',
    label: 'Leverage',
    options: [
      { value: '1:100', label: '1:100' },
      { value: '1:200', label: '1:200' },
      { value: '1:500', label: '1:500' },
    ],
  },
];

export const LIVE_ACCOUNT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'pending', label: 'Pending' },
    ],
  },
  {
    id: 'accountType',
    label: 'Account Type',
    options: [
      { value: 'Standard', label: 'Standard' },
      { value: 'Premium', label: 'Premium' },
      { value: 'VIP', label: 'VIP' },
    ],
  },
  {
    id: 'verificationStatus',
    label: 'Verification',
    options: [
      { value: 'verified', label: 'Verified' },
      { value: 'pending', label: 'Pending' },
      { value: 'unverified', label: 'Unverified' },
    ],
  },
  {
    id: 'currency',
    label: 'Currency',
    options: [
      { value: 'USD', label: 'USD' },
      { value: 'EUR', label: 'EUR' },
      { value: 'GBP', label: 'GBP' },
    ],
  },
];

export const IB_ACCOUNT_FILTER_FIELDS: FilterField[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'pending', label: 'Pending' },
    ],
  },
  {
    id: 'tier',
    label: 'Tier',
    options: [
      { value: 'Bronze', label: 'Bronze' },
      { value: 'Silver', label: 'Silver' },
      { value: 'Gold', label: 'Gold' },
      { value: 'Platinum', label: 'Platinum' },
    ],
  },
];
